import { useEffect, useState } from 'react';

export function useBreakpoints() {
  const get = () => {
    const w = window.innerWidth;
    return {
      width: w,
      xs: w <= 320,
      mb: w <= 420,
      sm: w > 320 && w <= 767,
      md: w > 767 && w <= 1023,
      lg: w > 1023 && w <= 1200,
      xl: w > 1200,
      isMobile: w <= 767,
    };
  };

  const [bp, setBp] = useState(get);

  useEffect(() => {
    const onResize = () => setBp(get());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return bp;
}
